import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../Badge';

export default function BadgeRow({ design, execution }) {
  return (
    <div className="mb-2 d-flex gap-2">
      <Badge rating={design} prefix="Design" />
      <Badge rating={execution} prefix="Exec" />
    </div>
  );
}

BadgeRow.propTypes = {
  design: PropTypes.number,
  execution: PropTypes.number
};
